import React from 'react';
import CustomIcon from 'common/components/icon/Icon';

export const svgEditPencil = (id) => {
  return <CustomIcon iconName='pencil' id={id} className='edit_pencil' />;
};
